import { _getQueryString } from 'cupshe-utils'

import router from '@/router'
import { menu_tree_get } from 'server/modules/351.js'
import { initMenuList, getMenuItem } from '../../utils/mfe'
import { PORTAL_ROUTER_TAG_LIST, getItem, setItem } from '../../utils/utils'

let menuItems = []
let uweb = []
let menusByPath = {}
let obj = {}
let systemId = '',
  systemName = ''
const deepItem = childrens => {
  childrens.forEach(element => {
    const { menuPath, menuName, id, parentId } = element
    if (parentId === 0) {
      obj = {
        systemId: id,
        menuName: '',
        openKeys: [],
        selectedKeys: []
      }
      systemId = id
      systemName = menuName
    }
    menuItems.push(
      Object.assign(element, {
        systemId,
        systemName
      })
    )

    if (element.childrenList) {
      deepItem(element.childrenList)
    } else {
      obj.menuPath = menuPath
      obj.menuName = menuName
      obj.selectedKeys = [menuPath]
      menusByPath[menuPath] = Object.assign({}, obj)
    }
  })
}

function getItemMenuNameEn(menuName, menuPath) {
  const list = menuItems.filter(item => item.menuName === menuName)
  let menuNameEn = ''
  if (list.length === 1) {
    menuNameEn = list[0].menuNameEn || list[0].menuName
  } else if (list.length > 1) {
    let target = list.find(item => item.menuPath === menuPath)
    if (!target) {
      target = list.find(item => menuPath.indexOf(item.menuPath) !== -1)
    }
    if (target) {
      menuNameEn = target.menuNameEn || target.menuName
    }
  }
  if (!menuNameEn) {
    const target =
      menuItems.find(item => item.menuPath === menuPath) ||
      menuItems.find(item => menuPath.indexOf(item.menuPath) !== -1)
    if (target) {
      menuNameEn = target.menuNameEn || target.menuName
    }
  }
  return menuNameEn || menuName
}

const removeIframe = menuPath => {
  const tagDom = document.getElementById(menuPath)
  if (tagDom) {
    tagDom.remove()
  }
}

const onDelete = (state, index) => {
  const item = state.routerTags[index]
  state.routerTags.splice(index, 1)
  removeIframe(item.menuPath)
  if (state.routerTags.length === 0) {
    router.push('/home')
  }
}

export default {
  namespaced: true,
  state: {
    // 权限菜单
    menus: [],
    // 收藏菜单
    favoriteMenus: [],
    userInfo: {
      jobNumber: '',
      email: '',
      // 登陆人的信息
      userId: '',
      userName: '',
      token: null,
      avatar: null,
      dingTalkUserId: null
    },
    menuList: [],
    routerTags: getItem(PORTAL_ROUTER_TAG_LIST, 'session', []),
    maxMenuTabNumber: 20,
    menusByPath: {},
    activeMenu: null,
    activeMenuKey: 0
  },
  mutations: {
    setActiveMenuKey(state, index) {
      state.activeMenuKey = index
      state.activeMenu = state.routerTags[index]
    },
    updateMenus(state, data) {
      // 变更状态
      const index = data.findIndex(item => item.menuName === '统一网站')
      if (index === -1) {
        state.menus = data || []
      } else {
        const item = data.splice(index, 1)[0]
        state.menus = [...item.childrenList, ...data]
      }
    },
    // 收藏菜单
    updateFavoriteMenus(state, newItem) {
      try {
        let menuList = []
        if (!newItem) {
          state.favoriteMenus = []
          menuItems.map(item => {
            if (item.favorite === 1) {
              const idx = menuList.findIndex(
                menu => menu.menuName === item.menuName
              )
              if (idx > -1) {
                menuList[idx] = {
                  ...menuList[idx],
                  menuName:
                    menuList[idx].systemName + '-' + menuList[idx].menuName
                }
                menuList.push({
                  ...item,
                  menuName: item.systemName + '-' + item.menuName
                })
              } else {
                menuList.push(item)
              }
            }
          })
        } else {
          menuList = [...state.favoriteMenus]
          const idx = menuList.findIndex(menu => menu.id === newItem.id)
          if (newItem.favorite === 1 && idx === -1) {
            menuList.push(newItem)
          } else if (newItem.favorite === 0 && idx > -1) {
            menuList.splice(idx, 1)
          }
        }
        state.favoriteMenus = menuList
      } catch (err) {
        console.error(err)
      }
    },
    updateMenuList(state, data) {
      deepItem(data, '')
      // 变更状态
      state.menuList = menuItems || []
      state.menusByPath = menusByPath
    },
    updateTags(state, tags) {
      const removeTags = state.routerTags.filter(
        item => !tags.find(tag => tag.menuPath === item.menuPath)
      )
      state.routerTags = tags
      if (removeTags.length) {
        removeTags.forEach(item => {
          removeIframe(item.menuPath)
        })
      }
      setItem(PORTAL_ROUTER_TAG_LIST, state.routerTags, 'session')
    },
    /**
     * 设置路由的历史记录
     * @param {*} state
     * @param {*} payload
     * @param {*} operateType  null 添加   1 删除  2 清空
     */
    saveHistoryRouter(state, payload) {
      // 子页面传递路由
      if (payload.data) {
        const data = getMenuItem(payload.data, state.menuList)
        if (!data.menuNameEn || /[\u4e00-\u9fa5]/.test(data.menuNameEn)) {
          data.menuNameEn =
            getItemMenuNameEn(data.menuName, data.menuPath) || data.menuName
        }
        if (!data.systemId) {
          data.systemId = getItem('otherSystemId')
        }
        if (data.menuPath === '/') {
          return false
        }
        let index = state.routerTags.findIndex(tag => {
          if (data.singleTab && data.basePath) {
            return tag.basePath === data.basePath
          }
          return tag.menuPath === data.menuPath
        })
        if (index > -1) {
          if (data.isDelete) {
            onDelete(state, index)
          } else if (
            // 存在相同子详情页，不同入参页面
            data.basePath === state.routerTags[index].basePath
          ) {
            if (
              data.singleTab ||
              data.menuName === state.routerTags[index].menuName
            ) {
              state.routerTags.splice(index, 1, data)
            } else {
              state.routerTags.push(data)
            }
          } else {
            state.routerTags.splice(index, 1, data)
          }
        } else {
          state.routerTags.push(data)
          index = state.routerTags.length - 1
        }
        if (state.routerTags.length > state.maxMenuTabNumber) {
          onDelete(state, 0)
          index = state.routerTags.length - 1
        }
        state.activeMenuKey = index
        state.activeMenu = state.routerTags[index]
      } else if (payload.index !== undefined) {
        // 移除menu tab
        if (payload.index === -1) {
          state.routerTags = []
        } else if (payload.index > -1) {
          // 根据索引删除 menu tab
          onDelete(state, payload.index)
          if (state.activeMenuKey >= payload.index) {
            if (state.activeMenuKey > 0) {
              state.activeMenuKey--
            } else {
              state.activeMenuKey = 0
            }
            state.activeMenu = state.routerTags[state.activeMenuKey]
          }
        }
      }
      setItem(PORTAL_ROUTER_TAG_LIST, state.routerTags, 'session')
    },
    // 维护用户登录信息
    saveUserInfo(state, obj) {
      const { id, name, token, email, jobNumber, avatar, dingTalkUserId } = obj
      state.userInfo = {
        userId: id,
        userName: name,
        token: token,
        email: email,
        jobNumber: jobNumber,
        avatar,
        dingTalkUserId
      }
      setItem('token', token)
    },
    SET_RESETSTATE(state) {
      Object.assign(state, {
        userInfo: {},
        // 权限菜单
        menus: [],
        menuList: [],
        routerTags: [],
        maxMenuTabNumber: 20
      })
    }
  },
  actions: {
    // actions一般是处理异步逻辑
    async GetMenusAction({ commit }) {
      const result = await menu_tree_get().catch(e => {
        console.log(e)
      })
      if (result && result.success) {
        const {
          data: { list }
        } = result
        let dataList = []
        const index = list.findIndex(item => {
          return item.menuName === '统一网站'
        })
        if (index === -1 || list[index].childrenList.length === 0) {
          dataList.push({
            menuName: '首页',
            menuNameEn: 'Home',
            menuPath: '/home',
            menuType: 2,
            parentId: 0
          })
        }
        const data = initMenuList([...dataList, ...list])
        menuItems = []
        menusByPath = {}
        systemId = ''
        systemName = ''
        obj = {
          systemId: '',
          menuName: '',
          menuCode: '',
          openKeys: [],
          selectedKeys: []
        }
        commit('updateMenuList', data)
        commit('updateMenus', data)
        commit('updateFavoriteMenus')
      }
    }
  }
}
